import { downloadAttachment } from '../../../../utils/vuex';
import formMixin from '../../formMixin';
import NiotaClassicApiService from '../../../../services/niotaClassicApiService';
import { mapState } from 'vuex';
import { vuetifyColors } from '../../../../utils/themes';
import get from 'lodash/get';
import compact from 'lodash/compact';
import filter from 'lodash/filter';
import every from 'lodash/every';
import isNull from 'lodash/isNull';
import has from 'lodash/has';
import clone from 'lodash/clone';
import set from 'lodash/set';
import isArray from 'lodash/isArray';
import pick from 'lodash/pick';

export default {
  mixins: [formMixin],
  props: {},
  data: function () {
    return {
      headers: [],
      contents: [],
      deviceProfiles: [],
      connectivityPlans: [],
      datasourceType: null,
      commonDeviceForms: [
        { map: 'title', variable: 'Device Title', userInfo: 'Required' },
        { map: 'eui', variable: 'Device EUI', userInfo: 'Required' },
        { map: 'applKey', variable: 'Application Key', userInfo: 'Required if OTAA' },
        { map: 'description', variable: 'Device description', userInfo: 'Optional' },
        { map: 'tags', variable: 'Device tags', userInfo: 'Optional' },
        { map: 'deviceAddress', variable: 'Device Address', userInfo: 'Required if ABP' },
        { map: 'netwSessionKey', variable: 'Network Session Key', userInfo: 'Required if ABP' },
        { map: 'applSessionKey', variable: 'Application Session Key', userInfo: 'Required if ABP' },
        { map: 'specOrga', variable: 'Firefly Organization ID', userInfo: 'Optional' },
        { map: 'class_c', variable: 'Class C Activation', userInfo: 'Optional' },
        { map: 'lat', variable: 'Latitude', userInfo: 'Optional' },
        { map: 'lon', variable: 'Longitude', userInfo: 'Optional' },
        {
          map: 'override_location',
          variable: 'Synchronize Location from settings in niota application',
          userInfo: 'Optional',
        },
        {
          map: 'LoraSigfox_Key_Data_Auth',
          variable: `${this.$i18n_t('NiotaClassic.Devices.form.properties')}: LoraSigfox_Key_Data_Auth`,
          userInfo: 'Optional',
        },
        {
          map: 'LoraSigfox_Key_Data_Enc',
          variable: `${this.$i18n_t('NiotaClassic.Devices.form.properties')}: LoraSigfox_Key_Data_Enc`,
          userInfo: 'Optional',
        },
        {
          map: 'extra_field',
          variable: this.$i18n_t('NiotaClassic.Devices.form.properties'),
          userInfo: 'Optional',
        },
        {
          map: 'applicationEUI',
          variable: this.$i18n_t('NiotaClassic.Devices.details.applicationEui'),
          userInfo: 'Optional',
        },
        {
          map: 'motionIndicator',
          variable: this.$i18n_t('NiotaClassic.Devices.form.motionIndicator'),
          userInfo: 'Optional',
        },
        {
          map: 'battery_alert_level',
          variable: this.$i18n_t('NiotaClassic.Devices.form.alertLevel'),
          userInfo: 'Optional',
        },
        {
          map: 'battery_warning_level',
          variable: this.$i18n_t('NiotaClassic.Devices.form.warningLevel'),
          userInfo: 'Optional',
        },
        {
          map: 'minimum_packets_threshold',
          variable: this.$i18n_t('NiotaClassic.Devices.form.threshold'),
          userInfo: 'Optional',
        },
      ],
      mappedItems: {},
      allMapped: false,
      cardBorder: null,
      applications: [],
      originators: [],
      deviceTypes: [],
      datasources: [],
      newColumn: false,
      columnName: '',
      buttons: [
        {
          icon: 'fal fa-check',
          action: 'apply',
          tooltip: this.$i18n_t('Common.apply'),
        },
      ],
      editDialog: false,
      editCols: {},
      editButtons: [
        {
          icon: 'fal fa-check',
          title: this.$i18n_t('Common.apply'),
          action: 'save',
        },
        {
          icon: 'fal fa-times',
          color: 'danger',
          action: 'close',
          tooltip: this.$i18n_t('Common.cancel'),
        },
      ],
      specialFields: ['extra_field', 'LoraSigfox_Key_Data_Enc', 'LoraSigfox_Key_Data_Auth'],
      allErrorMessages: {
        eui: this.$i18n_t('NiotaClassic.Devices.errors.eui'),
        deviceAddress: this.$i18n_t('NiotaClassic.Devices.errors.deviceAddress'),
        netwSessionKey: this.$i18n_t('NiotaClassic.Devices.errors.netwSessionKey'),
        applSessionKey: this.$i18n_t('NiotaClassic.Devices.errors.applSessionKey'),
        applKey: this.$i18n_t('NiotaClassic.Devices.errors.applKey'),
        title: this.$i18n_t('NiotaClassic.Devices.errors.title'),
        connectivityPlan: this.$i18n_t('NiotaClassic.Devices.errors.connectivityPlan'),
        manufacturerModel: this.$i18n_t('NiotaClassic.Devices.errors.manufacturerModel'),
        applicationId: this.$i18n_t('NiotaClassic.Devices.errors.applicationId'),
        originatorId: this.$i18n_t('NiotaClassic.Devices.errors.originatorId'),
        lat: this.$i18n_t('NiotaClassic.Devices.errors.latBeNumber'),
        lon: this.$i18n_t('NiotaClassic.Devices.errors.lonBeNumber'),
      },
      counter: 0,
      progress: false,
      uploadProgress: 0,
      error: false,
      start: 0,
      end: 10,
      limit: 10,
      processed: 0,
      errorCounter: 0,
      editColsIndex: null,
      importedCounter: 0,
      errorList: '',
      mappedHeader: [],
      uploadListKey: 1,
      properties: [
        'applicationEUI',
        'motionIndicator',
        'battery_alert_level',
        'battery_warning_level',
        'minimum_packets_threshold',
      ],
      actilityOptionsIsLoading: false,
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions']),
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    disableBtn() {
      if (!this.allMapped) {
        return true;
      }
      return false;
    },
  },
  watch: {},
  created() {
    this.initData();
  },
  methods: {
    initData() {
      this.applicationsFetchPlain();
      this.originatorFetchPlain();
      this.deviceTypeFetchPlain();
      this.dataSourcesFetchPlain();
    },
    fetchActilityOptions() {
      this.actilityOptionsIsLoading = true;
      NiotaClassicApiService.fetchActilityOptions(this.formItem.originatorId)
        .then((res) => {
          let connectivityPlans = get(res, 'data.connectivity_plans');
          let deviceProfiles = get(res, 'data.device_profiles');
          if (isArray(connectivityPlans)) {
            this.connectivityPlans = get(res, 'data.connectivity_plans');
          } else {
            this.$snack(connectivityPlans, 'error');
          }
          if (isArray(deviceProfiles)) {
            this.deviceProfiles = get(res, 'data.device_profiles');
          } else {
            this.$snack(deviceProfiles, 'error');
          }
        })
        .catch((error) => {
          this.$snack(this.$i18n_t('NiotaClassic.Devices.snacks.errorFindingActilityOptions'), 'error');
          console.error(error);
        })
        .finally(() => {
          this.actilityOptionsIsLoading = false;
        });
    },
    filterItems(item, queryText) {
      return (
        item.title.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1 ||
        item.id.toString().toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1
      );
    },
    filterConnectivityPlan(item, queryText) {
      return (
        item.name.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1 ||
        item.id.toString().toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1
      );
    },
    filterMapper(item, queryText) {
      return (
        item.variable.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1 ||
        item.userInfo.toString().toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1
      );
    },
    selcetedOriginator(originator) {
      if (originator) {
        let datasourceId = originator.datasourceId;
        if (datasourceId) {
          let datasource = this.datasources.find((datasource) => datasource.id === datasourceId);
          if (datasource) {
            this.datasourceType = datasource.type;
          }
        }
        this.formItem.originatorId = originator.id;
        this.formItem.cType = this.datasourceType;
        if (this.datasourceType === 'firefly_mqtt' || this.datasourceType === 'firefly') {
          this.formItem.cType = 'firefly';
        }
        if (this.datasourceType === 'actility') {
          this.fetchActilityOptions();
        }
        this.contents = this.contents.map((device) => {
          device['originator'] = originator;
          return device;
        });
      } else {
        this.datasourceType = null;
      }
    },
    selcetedManufacturerModel(deviceProfiles) {
      if (deviceProfiles) {
        this.formItem.deviceProfileId = deviceProfiles.id;
        delete this.formItem.device_profiles;
      }
    },
    selcetedConnectivityPlan(connectivityPlan) {
      if (connectivityPlan) {
        this.formItem.connectivityPlanId = connectivityPlan.id;
        delete this.formItem.connectivity_plans;
      }
    },
    startUpload() {
      if (this.allMapped) {
        this.cardBorder = null;
        this.errorCounter = 0;
        this.errorList = '';
        this.uploadProgress = 0;
        this.mappedHeader = Object.values(this.mappedItems);
        this.mapKeys();
        this.setCommonData();
        if (!this.error) {
          this.processCreate();
        } else {
          this.$snack(this.$i18n_t('NiotaClassic.Devices.details.statusErrorMsg'), 'error');
        }
      } else {
        this.$snack(this.$i18n_t('NiotaClassic.Devices.snacks.errorVariableMapping'), 'error');
        this.cardBorder = 'border-red';
      }
    },
    newRow() {
      let newItem = {};
      this.headers.forEach((header) => {
        // if (Object.keys(this.mappedItems).length) {
        //   // Actility Field
        //   let index = this.properties.indexOf(this.mappedItems[header.value]);
        //   if (this.mappedItems[header.value] === 'extra_field' || index !== -1) {
        //     newItem[header.value] = '';
        //   } else {
        //     newItem[this.mappedItems[header.value]] = '';
        //   }
        // } else {
        //   newItem[header.value] = '';
        // }
        newItem[header.value] = '';
      });
      this.contents.push(newItem);
    },
    openDialog() {
      this.newColumn = true;
    },
    addNewColmn() {
      if (this.columnName) {
        this.allMapped = false;
        this.headers.push({
          text: this.columnName.trim(),
          value: this.columnName.trim(),
          sortable: false,
        });
        this.contents = this.contents.map((device) => {
          device[this.columnName] = '';
          return device;
        });
        this.newColumn = false;
        this.columnName = '';
      }
    },
    mappingData() {
      let keys = Object.keys(this.mappedItems);
      if (keys.length === this.headers.length) {
        this.allMapped = true;
        // this.mapKeys();
      } else {
        this.allMapped = false;
      }
    },
    deleteVariable(index) {
      this.contents = this.contents.map((device) => {
        delete device[this.headers[index].text];
        return device;
      });
      delete this.mappedItems[this.headers[index].text];
      this.headers.splice(index, 1);
      this.mappingData();
    },
    deleteDeviceData(index) {
      this.contents.splice(index, 1);
    },
    setOtaa(value) {
      this.formItem.otaa = value ? value : false;
      this.contents = this.contents.map((device) => {
        device['otaa'] = value ? value : false;
        return device;
      });
    },
    setDeviceType(deviceTypeId) {
      this.contents = this.contents.map((device) => {
        device['deviceTypeId'] = deviceTypeId;
        return device;
      });
    },
    setApplicationId(applicationId) {
      this.contents = this.contents.map((device) => {
        device['applicationId'] = applicationId;
        return device;
      });
    },
    deleteColumn(index) {
      this.editCols = {};
      this.deleteVariable(index);
    },
    uploadedFile(csv) {
      this.clearForm();
      let lines = this.getLines(csv);
      this.getHeader(lines);
      for (let i = 1; i < lines.length; i++) {
        let obj = {};
        let currentline = lines[i].split(/[;\n]+/);
        for (let j = 0; j < this.headers.length; j++) {
          if (currentline[j]) {
            obj[this.headers[j].text.trim()] = currentline[j].trim();
          } else {
            obj[this.headers[j].text.trim()] = '';
          }
        }
        if (!every(obj, (v) => v === '' || isNull(v))) {
          this.contents.push(obj);
        }
      }
      this.headers = filter(this.headers, (header) => header.text !== 'msg' && header.text !== 'error');
    },
    getLines(csv) {
      let splittedResult = csv.split('\n');
      return splittedResult.filter((line) => line[0] !== '\n');
    },
    getHeader(lines) {
      let headers = filter(compact(lines[0].split(/[;\n]+/)), (header) => {
        return header.length > 1;
      });
      this.headers = headers.map((header) => {
        return {
          text: header.trim(),
          value: header.trim(),
          sortable: false,
        };
      });
    },
    applicationsFetchPlain() {
      NiotaClassicApiService.applicationsFetchPlain()
        .then((res) => {
          this.applications = res.data.applications;
        })
        .catch((error) => {
          this.applications = [];
          this.$snack(this.$i18n_t('NiotaClassic.Devices.snacks.errorFindingApplications'), 'error');
          console.error(error);
        });
    },
    originatorFetchPlain() {
      NiotaClassicApiService.originatorsFetchPlain(this.limit)
        .then((res) => {
          this.originators = res.data.originators;
        })
        .catch((error) => {
          this.originators = [];
          this.$snack(this.$i18n_t('NiotaClassic.Devices.snacks.errorFindingOriginators'), 'error');
          console.error(error);
        });
    },
    deviceTypeFetchPlain() {
      NiotaClassicApiService.deviceTypeFetchPlain()
        .then((res) => {
          this.deviceTypes = res.data.devicetypes;
        })
        .catch((error) => {
          this.deviceTypes = [];
          this.$snack(this.$i18n_t('NiotaClassic.Devices.snacks.errorFindingDeviceTypes'), 'error');
          console.error(error);
        });
    },
    dataSourcesFetchPlain() {
      NiotaClassicApiService.dataSourcesFetchPlain()
        .then((res) => {
          this.datasources = res.data.datasources;
        })
        .catch((error) => {
          this.deviceTypes = [];
          this.$snack(this.$i18n_t('NiotaClassic.Devices.snacks.errorFindingDatasources'), 'error');
          console.error(error);
        });
    },
    editItem(item, index) {
      this.editColsIndex = index;
      this.editCols = item;
      this.editDialog = true;
    },
    saveItem() {
      this.contents[this.editColsIndex] = this.editCols;
      this.editDialog = false;
      this.editCols = {};
      this.uploadListKey++;
    },
    mapKeys() {
      this.contents = this.contents.map((device) => {
        let newDevice = {};
        this.headers.forEach((header) => {
          let key = header.value;
          if (has(device, key)) {
            // Actility Field
            let _index = this.properties.indexOf(this.mappedItems[key]);
            if (_index !== -1) {
              newDevice = this.mapProperties(this.mappedItems[key], clone(device[key], true), newDevice);
              newDevice[key] = clone(device[key], true);
            } else {
              // ExtraField and Cyble5-devices
              let index = this.specialFields.indexOf(this.mappedItems[key]);
              if (index !== -1) {
                newDevice = this.mapExtraFields(device, this.mappedItems, key, newDevice);
                newDevice[key] = clone(device[key], true);
              } else {
                newDevice[this.mappedItems[key]] = clone(device[key], true);
              }
            }
          } else {
            newDevice[this.mappedItems[key]] = clone(device[this.mappedItems[key]], true);
          }
        });
        return newDevice;
      });
    },
    mapProperties(key, value, newDevice) {
      if (!newDevice.properties) {
        newDevice['properties'] = {};
      }
      set(newDevice, `properties.${key}`, value);
      return newDevice;
    },
    mapExtraFields(device, mappedKeys, key, newDevice) {
      let extraField = {};
      if (!newDevice.properties) {
        newDevice['properties'] = {};
      }
      if (!get(newDevice, 'properties.extraFields')) {
        set(newDevice, 'properties.extraFields', []);
      }
      let extraFields = get(newDevice, 'properties.extraFields');
      if (extraFields) {
        if (mappedKeys[key] === 'extra_field') {
          extraField = { icon: '', name: key, value: clone(device[key], true) };
        } else {
          extraField = { icon: '', name: mappedKeys[key], value: clone(device[key], true) };
        }
        newDevice.properties.extraFields.push(extraField);
      }
      return newDevice;
    },
    setCommonData() {
      let keys = Object.keys(this.formItem);
      this.contents = this.contents.map((device) => {
        keys.forEach((key) => {
          device[key] = this.formItem[key];
        });
        if (!device.cType) {
          let datasourceId = get(device, 'originator.datasourceId');
          if (datasourceId) {
            let datasource = this.datasources.find((datasource) => datasource.id === datasourceId);
            if (datasource) {
              device.cType = datasource.type;
            }
          }
        }
        device.valid = true;
        device.add = true;
        if (device) {
          this.validateData(device);
        }
        return device;
      });
    },
    validateData(device) {
      let msg = '';
      if (!device.eui) {
        msg += `${this.allErrorMessages['eui']}, `;
      }
      if (!device.title) {
        msg += `${this.allErrorMessages['title']}, `;
      }
      if (!device.applicationId) {
        msg += `${this.allErrorMessages['applicationId']}, `;
      }
      if (!device.originatorId) {
        msg += `${this.allErrorMessages['originatorId']}, `;
      }
      if (get(device, 'originator.datasource.type') === 'actility') {
        if (!device.deviceProfileId) {
          msg += `${this.allErrorMessages['manufacturerModel']}, `;
        }
        if (!device.connectivityPlanId) {
          msg += `${this.allErrorMessages['connectivityPlan']}, `;
        }
      }
      if (device.otaa) {
        if (!device.applKey) {
          msg += `${this.allErrorMessages['applKey']}, `;
        }
      }
      if (!device.otaa) {
        if (!device.deviceAddress) {
          msg += `${this.allErrorMessages['deviceAddress']}, `;
        }
        if (!device.netwSessionKey) {
          msg += `${this.allErrorMessages['netwSessionKey']}, `;
        }
        if (!device.applSessionKey) {
          msg += `${this.allErrorMessages['applSessionKey']}, `;
        }
      }
      msg = this.checkLatAndLon(device, msg);
      if (msg) {
        this.error = true;
        this.setState(device, true, msg);
      } else {
        this.setState(device, false, msg);
        this.error = false;
      }
    },
    checkLatAndLon(device, msg) {
      if (device.lat && isNaN(device.lat)) {
        msg += `${this.allErrorMessages['lat']}, `;
      }
      if (device.lon && isNaN(device.lon)) {
        msg += `${this.allErrorMessages['lon']}, `;
      }
      return msg;
    },
    setState(device, state = false, msg = null) {
      this.counter++;
      this.onProgressHandler();
      device.error = state;
      delete device.msg;
      if (state) {
        device.msg = msg;
        this.errorCounter++;
      }
    },
    processCreate() {
      this.counter = 0;
      this.processed = 0;
      this.start = 0;
      this.end = 10;
      this.nextBlock();
    },
    nextBlock() {
      let devices = this.contents.slice(this.start, this.end);
      this.processed = this.processed + devices.length;
      this.create(devices);
    },
    create(devices) {
      devices.forEach(async (device, index) => {
        await setTimeout(async () => await this.deviceCreate(device), index * 800);
      });
    },
    async deviceCreate(device) {
      this.progress = true;
      await NiotaClassicApiService.deviceCreate(device)
        .then((res) => {
          if (!res.err) {
            this.importedCounter++;
            this.setState(device);
          } else {
            this.$snack(res.err, 'error');
            this.setState(device, true, res.err);
            this.setToErrorList(clone(device));
          }
          this.nextStep();
        })
        .catch((error) => {
          const deviceRequestError = get(error, 'response.data.err', error.message);
          this.setState(device, true, deviceRequestError);
          this.setToErrorList(clone(device));
          this.nextStep();
        });
    },
    updateOriginatorId(item) {
      if (item.originator) {
        item.originatorId = item.originator.id;
        let datasourceId = get(item, 'originator.datasourceId');
        let datasource = this.datasources.find((datasource) => datasource.id === datasourceId);
        item.cType = datasource.type;
      } else {
        delete item.originator;
        delete item.originatorId;
      }
    },
    updateOtaa(event, item) {
      item.otaa = event ? event : false;
    },
    nextStep() {
      if (this.counter === this.processed) {
        this.start = this.start + this.limit;
        this.end = this.end + this.limit;
        this.nextBlock();
      }
      if (this.counter === this.contents.length) {
        this.progress = false;
        this.uploadListKey++;
        if (this.importedCounter > 0) {
          this.$snack(
            this.$i18n_tc('NiotaClassic.Devices.snacks.importMsgSuccess', this.importedCounter, {
              n: this.importedCounter,
            }),
            'success'
          );
        } else {
          this.$snack(this.$i18n_t('NiotaClassic.Devices.snacks.importMsgFailed'), 'error');
        }
        if (this.errorCounter > 0) {
          this.$snack(
            this.$i18n_tc('NiotaClassic.Devices.snacks.importMsgError', this.errorCounter, {
              n: this.errorCounter,
            }),
            'error'
          );
        }
      }
    },
    onProgressHandler() {
      this.uploadProgress = Math.round((this.counter / this.contents.length) * 100);
    },
    getColor(type) {
      return vuetifyColors[type];
    },
    setToErrorList(device) {
      device = this.pickFields(clone(device));
      if (!this.errorList) {
        let header = Object.keys(device);
        this.errorList = header.join(';');
        this.errorList += '\n';
      }
      let values = Object.values(device);
      this.errorList += values.join(';');
      this.errorList += '\n';
    },
    downloadList() {
      if (this.errorList) {
        const fileName = 'errorList.csv';
        downloadAttachment('text/plain;charset=utf-8', this.errorList, fileName);
      }
    },
    pickFields(device) {
      let fields = [...clone(this.mappedHeader), ...['error', 'msg']];
      return pick(device, fields);
    },
    clearForm() {
      this.headers = [];
      this.contents = [];
      this.mappedItems = {};
      this.allMapped = false;
      this.newColumn = false;
      this.columnName = '';
      this.counter = 0;
      this.progress = false;
      this.uploadProgress = 0;
      this.error = false;
      this.start = 0;
      this.end = 10;
      this.limit = 10;
      this.processed = 0;
      this.errorCounter = 0;
      this.editColsIndex = null;
      this.importedCounter = 0;
      this.errorList = '';
      this.mappedHeader = [];
    },
  },
};
